// extracted by mini-css-extract-plugin
export var logotype = "PageHome-module--logotype--ebPsY";
export var content = "PageHome-module--content--37dW2";